import React from 'react';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import Confirm from 'components/Confirm';
import messages from '../../ScheduleForm.messages';

const DeleteScheduleModal = ({ terminationType }) => (
  <Confirm
    title={<Message message={messages.modals.deleteSchedule.title} />}
    cancelNode={<Message message={messages.modals.cancel} />}
    acceptNode={<Message message={messages.modals.submit} />}
    isOpen>
    <Message
      id={terminationType}
      messages={messages.modals.deleteSchedule.terminationTypes}
      values={{
        a: text => (
          <a href="/classes" rel="noopener noreferrer">
            {text}
          </a>
        ),
      }}
    />
  </Confirm>
);

DeleteScheduleModal.propTypes = {
  terminationType: PropTypes.string,
};

export default DeleteScheduleModal;
